import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Tablet } from 'lucide-react';
import { apiService } from '../services/api';
import { User as UserType } from '../types';

interface TableLoginScreenProps {
  onLogin: (user: UserType) => void;
}

const TableLoginScreen: React.FC<TableLoginScreenProps> = ({ onLogin }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    if (!name || !password) {
      setError('Vă rugăm să introduceți numele și parola mesei');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await apiService.login({ name, password });
      
      if (response.success && response.user && response.user.role === 'table') {
        onLogin(response.user);
      } else {
        setError('Acest cont nu are permisiunea de a accesa interfața mesei');
      }
    } catch (error) {
      setError('Eroare la conectarea cu serverul');
      console.error('Table login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-20 h-20 bg-blue-600 rounded-2xl flex items-center justify-center mb-4">
            <Tablet className="w-12 h-12 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-800">
            Autentificare Masă
          </CardTitle>
          <p className="text-gray-600">Interfață pentru monitorizarea echipelor</p>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-lg font-medium">
              Nume Masă:
            </Label>
            <Input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="h-12 text-lg"
              placeholder="Introduceți numele mesei"
              disabled={isLoading}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-lg font-medium">
              Parola:
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 text-lg"
              placeholder="Introduceți parola"
              disabled={isLoading}
              onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <Button
            onClick={handleLogin}
            className="w-full h-14 text-lg bg-blue-600 hover:bg-blue-700"
            disabled={isLoading}
          >
            <Tablet className="w-5 h-5 mr-2" />
            {isLoading ? 'Se conectează...' : 'Conectează Masa'}
          </Button>

        </CardContent>
      </Card>
    </div>
  );
};

export default TableLoginScreen;